import type { ReactNode } from 'react'
import { VpLoader } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'

interface DataFallbackProps<T> {
  value: T | null | undefined
  fallbackKey: string
  isLoading?: boolean
  isError?: boolean
  isEmpty?: (value: T) => boolean
  loader?: ReactNode
  children: (value: T) => ReactNode
}

export function DataFallback<T>({
  value,
  fallbackKey,
  isLoading = false,
  isError = false,
  isEmpty,
  loader = <VpLoader size="small" />,
  children,
}: Readonly<DataFallbackProps<T>>) {
  const { t } = useTranslation()

  if (isLoading)
    return loader

  const isBlankString = typeof value === 'string' && value.trim() === ''

  if (isError || value == null || isBlankString || isEmpty?.(value))
    return t(fallbackKey)

  return children(value)
}
